import { processRequest } from '../../services/Api';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import i18n from 'i18next';
import { selectBookActionTypes, SELECT_BOOK_MODAL_FORM } from './Constants';
import { historyPush } from '../../services/History';
import * as selectBookActions from './Actions';
import * as notificationActions from '../../components/notification/Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as sharedActions from '../shared/Actions';
import { selectBookDataObj, userId } from './Selectors';

export default function* () {
	yield all([
		yield takeLatest(
			selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER,
			handleSelectDetailsOfUserRequest,
		),
		yield takeLatest(selectBookActionTypes.GET_SELECT_BOOK, handleSelectBookRequest),
		yield takeLatest(selectBookActionTypes.ADD_SELECTION, handleAddSelectionRequest),
		yield takeLatest(
			selectBookActionTypes.SBM_GET_EDUCATION_TYPES,
			handleEducationTypesRequest,
		),
		yield takeLatest(selectBookActionTypes.SBM_GET_USER_DETAILS, handleGetUserDetailsRequest),
		yield takeLatest(selectBookActionTypes.SET_CANDIDATE_BOOK, handleSetCandidateBookRequest),
	]);
}

export function* handleSelectDetailsOfUserRequest({ payload }) {
	try {
		const { subjectId } = payload;
		const { data } = yield call(processRequest, `subjects/${subjectId}/user_books`);
		yield put(selectBookActions.getSubjectDetailsOfUserSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(selectBookActions.getSubjectDetailsOfUserError());
	}
}

export function* handleSelectBookRequest({ payload }) {
	try {
		const { subjectId, queries, offset } = payload;

		const queriesData = {
			...{
				type: 'books',
				subject_id: subjectId,
				limit: 24,
			},
			...queries,
		};

		offset && (queriesData.offset = offset);

		const { data } = yield call(processRequest, `search`, 'GET', queriesData);

		const formattedData = { ...data.result_sections[0] };

		if (offset) {
			const selectBookData = yield select(selectBookDataObj);
			formattedData.results = [...selectBookData.results, ...formattedData.results];
		}

		yield put(selectBookActions.getSelectBookSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(selectBookActions.getSelectBookError());
	}
}

export function* handleAddSelectionRequest(action) {
	try {
		const {
			data: { selectionIds, subjectId, subjectName, singleBook },
		} = action.payload;

		const { data } = yield call(
			processRequest,
			`public/books/replace_subject_collection`,
			'PUT',
			{
				book_ids: selectionIds,
			},
		);

		yield put(
			notificationActions.createNotification(
				i18n.t(
					`select_book.${
						singleBook ? 'selected_book_notification' : 'selected_books_notification'
					}`,
				),
			),
		);

		if (data.suggested_subjects)
			yield put(sharedActions.getUserSuggestedSubjectsSuccess(data.suggested_subjects));

		yield call(historyPush, `/subjects/${subjectId}/${subjectName}`);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(selectBookActions.addSelectionError());
	}
}

export function* handleEducationTypesRequest({ payload }) {
	try {
		const { data } = yield call(
			processRequest,
			`countries/${payload.countryId}/education_types`,
		);

		yield put(selectBookActions.getEducationTypesSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(selectBookActions.getEducationTypesError());
	}
}

export function* handleGetUserDetailsRequest() {
	try {
		const id = yield select(userId);
		const { data } = yield call(processRequest, `users/${id}`);

		yield put(selectBookActions.getUserDetailsSuccess(data.user));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(selectBookActions.getUserDetailsError());
	}
}

export function* handleSetCandidateBookRequest(action) {
	try {
		const { data } = action.payload;

		yield call(processRequest, 'book_requests', 'POST', data);
		yield put(
			notificationActions.createNotification(
				i18n.t('modals.select_book_modal.candidate_book_notification'),
			),
		);
		yield put(selectBookActions.setCandidateBookSuccess());
		yield put(selectBookActions.toggleSelectBookModal(false));
		yield put(selectBookActions.resetForm(SELECT_BOOK_MODAL_FORM));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(selectBookActions.setCandidateBookError());
	}
}
